import PolicyLayout from './PolicyLayout';
import { POLICY_UPDATED, SALES_EMAIL } from '../constants/site';

export default function DeliveryPolicy() {
  return (
    <PolicyLayout
      title="Delivery Policy"
      updated={POLICY_UPDATED}
      intro="Everything we sell is delivered electronically. There is nothing to ship and no delivery charge."
    >
      <h2>What you receive</h2>
      <p>
        Each order is fulfilled by email and includes your publisher product key, the official
        download link for the edition and version you bought, and installation notes for
        Windows or Mac.
      </p>

      <h2>Delivery times</h2>
      <p>
        Orders placed and paid for on a working day are delivered the same day, usually within
        a few hours. Orders placed outside working hours are delivered on the next working
        morning.
      </p>

      <h2>If nothing arrives</h2>
      <p>
        Check your spam and quarantine folders first, since messages containing licence keys
        are sometimes filtered. If it is still missing, email{' '}
        <a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a> and we will resend to an alternate
        address.
      </p>

      <h2>Installation help</h2>
      <p>
        Guided installation is included with every licence. Once you have your key, submit a
        request on the site and a certified expert will walk through setup, accounting data
        file creation and data migration with you.
      </p>

      <h2>Physical media</h2>
      <p>
        We do not ship discs or USB media. Current accounting software versions are distributed
        as downloads only, and installing from an old disc is the most common cause of version
        mismatch errors.
      </p>
    </PolicyLayout>
  );
}
